// Fixed-format UI positions (PIN dots, seats, particles), not mutable data rows.
const slots = new Map();
export const fixedSlots = (count) => {
  if (!slots.has(count)) slots.set(count, Array.from({ length: count }, (_, index) => ({ id: `slot-${index}`, index })));
  return slots.get(count);
};

// Repeated, stateless rewards may have no server ID. Identity follows their
// immutable content, with occurrence suffixes only for indistinguishable copies.
export const keyedEntries = (items, identity) => {
  const counts = new Map();
  return items.map((item) => {
    const base = String(identity(item));
    const occurrence = counts.get(base) || 0;
    counts.set(base, occurrence + 1);
    return { item, key: `${base}:${occurrence}` };
  });
};